import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

type StyledStickerProps = {
  isGreen?: boolean;
};

const Container = styled.div`
  margin-bottom: 6.4rem;
`;

const StickerBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex-wrap: wrap;
`;

const GenderBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  flex-wrap: wrap;
`;

const Sticker = styled.span<StyledStickerProps>`
  padding: 0.2rem 0.6rem;

  background-color: ${({ isGreen }) => pickColor(isGreen ? 'green' : 'grayDarkSecondary')};
  color: ${pickColor('white')};
  border-radius: 0.25rem;
  display: inline-block;
  width: fit-content;

  ${getFontScale('xs')};
`;

const CustomerName = styled.span`
  display: block;
  max-width: 23rem;
  white-space: normal;
  word-break: break-word;
`;

export { Container, CustomerName, Sticker, StickerBox, GenderBox };
